import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment';

// components
import { CButton, CImage, CDateRangePicker } from '@coreui/react-pro'
import Select from 'react-select';
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnExpenseList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'
import { 
  singleExpenseCategoryOptionsSelect,
  singleProjectsOptionsSelect
} from '../../helpers/format-options'
import { customStyles } from '../../components/custom-styles/selectStyles'

const ExpenseList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [expenseList, setExpenseList] = useState([]);
  const [expenseListCount, setExpenseListCount] = useState(0);
  const [expenseListPerPage, setExpenseListPerPage] = useState(10);
  const [activeExpenseListPage, setActiveExpenseListPage] = useState(1);
  const [searchExpenseListFilter, setSearchExpenseListFilter] = useState("");
  const [columnExpenseListSorter, setColumnExpenseListSorter] = useState({ column: "updatedAt", state: "desc" });

  const [expenseCategoryOptions, setExpenseCategoryOptions] = useState([])
  const [projectOptions, setProjectOptions] = useState([])
  const [filterStartDate, setFilterStartDate] = useState(null)
  const [filterEndDate, setFilterEndDate] = useState(null)

  const [columnFilter, setColumnFilter] = useState({})
  const [updateColumnList, setUpdateColumnList] = useState(columnExpenseList)

  useEffect(() => {
    let queries = {
      search: searchExpenseListFilter,
      limit: expenseListPerPage,
      offset: expenseListPerPage * activeExpenseListPage - expenseListPerPage,
      sort:
        (columnExpenseListSorter &&
          `${columnExpenseListSorter.column}%${columnExpenseListSorter.state}`) ||
        "",
    };
    if (columnFilter) {
      Object.keys(columnFilter).forEach((key) => {
        if (columnFilter[key]) {
          queries[key] = columnFilter[key].value
        } else {
          queries[key] = ''
        }
      })
    }
    queries = formUrlQuery(queries);
    fetchAllExpenses(queries);
  }, [
    searchExpenseListFilter,
    expenseListPerPage,
    activeExpenseListPage,
    columnExpenseListSorter,
    columnFilter
  ]);

  useEffect(() => {
    let columnList = updateColumnList?.map((list) => {
      let data = list

      if (data.key == 'project_name' && projectOptions?.length > 0) {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={projectOptions}
              value={columnFilter.project_id}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnFilter((prevState) => ({
                  ...prevState,
                  project_id: selectedValue
                }));
                setActiveExpenseListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'category_name' && expenseCategoryOptions?.length > 0) {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={expenseCategoryOptions}
              value={columnFilter.category_id}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnFilter((prevState) => ({
                  ...prevState,
                  category_id: selectedValue
                }));
                setActiveExpenseListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'date') {
        data.filter = () => {
          return (
            <CDateRangePicker
              footer
              cleaner
              size="sm"
              startDate={filterStartDate}
              endDate={filterEndDate}
              onStartDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterStartDate(itemDate)
                  
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    start_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterEndDate) {
                    setActiveExpenseListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    start_date: null
                  }));
                }
              }}
              onEndDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterEndDate(itemDate)
                  
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    end_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterStartDate) {
                    setActiveExpenseListPage(1)
                  }
                } else {
                  setColumnFilter((prevState) => ({
                    ...prevState,
                    end_date: null
                  }));
                }
              }}
            />
          )
        }
      }

      return data
    })

    setUpdateColumnList(columnList)
  }, [columnFilter, expenseCategoryOptions, projectOptions])

  useEffect(() => {
    fetchAllExpenseCategories()
    fetchAllProject()
  }, [])

  const handleSearchItems = (search) => {
    setActiveExpenseListPage(1)
    setSearchExpenseListFilter(search);
  }

  const fetchAllExpenses = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/expense?${queries}`
    })
      .then(({ data }) => {
        let tempExpenseList = data?.value
        tempExpenseList = tempExpenseList.map((item, index) => {
          return {
            ...item,
            category_name: item?.category?.name || "-",
            project_name: item?.project?.name || "-",
          }
        })
        setExpenseList(tempExpenseList);
        if (activeExpenseListPage === 1) {
          setExpenseListCount(data?.count);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const fetchAllExpenseCategories = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/expense/category/option/list",
    })
      .then(({ data }) => {
        if (data?.success) {
          setExpenseCategoryOptions(singleExpenseCategoryOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllProject = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/project",
    })
      .then(({ data }) => {
        if (data?.success) {
          setProjectOptions(singleProjectsOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/expense/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllExpenses()
          showSuccess('Expense has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/expense/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={showConfirmDelete?.item?.name}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-md-flex justify-content-md-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/expense/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Expense
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Expense List</h4>}
        bodyContent={
          <AppTable
            expenseListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnExpenseList}
            tableContent={expenseList}
            contentPerPage={expenseListPerPage}
            activeContentPage={activeExpenseListPage}
            contentCount={expenseListCount}
            searchContentFilter={searchExpenseListFilter}
            setActiveContentPage={setActiveExpenseListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setExpenseListPerPage}
            setColumnContentSorter={setColumnExpenseListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
            isShowColumnFilter={true}
            isShowButtonDuplicate={true}
          />
        }
      />
    </>
  )
}

export default ExpenseList